import { TextCollection } from 'app/types-shared';

function textDescription(collection: TextCollection, id: number): string {
  if (!collection || !collection.texts) {
    return '';
  }
  const text = collection.texts.find(t => !!t.id && t.id.no === id);
  return (text && text.description) || '';
}

/**
 * Partial function to retreive description property from props.
 * 
 * @export
 * @param predicate to return {TextDictionary} texts
 * @returns
 */
export function createDescriptionSelector(collection: TextCollection) {
  return (id: number) => textDescription(collection, id);
}
